import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
//js
import { CallService } from "../Js/Script";
import { SetSearch, UseSearch } from "../Js/Context/SearchCntx";
//img
import email from "../Resources/Images/email.svg";
import password from "../Resources/Images/password.svg";
import "../Css/Login.css";
export default function Login() {
  const [stLogin, setStLogin] = useState({
    passWord: "",
    email: "",
  });
  const setStSearch = SetSearch();
  const navigate = useNavigate();
  const [states, setStates] = useState({
    ShowAlertInfo: true,
    ShowErrorTxt: { show: false, txt: "" },
  });
  const onLogin = (e, email, password) => {
    CallService(
      "Authentication",
      { email: email, password: password },
      "POST",
      false,
      false,
    )
      .then((res) => {
        localStorage.setItem("Ticket", res.token);
        localStorage.setItem("Role", res.user[0].userRole);
        localStorage.setItem("id", res.user[0].userId);
        localStorage.setItem(
          "Name",
          res.user[0].firstName + " " + res.user[0].lastName,
        );
        localStorage.setItem("mobile", res.user[0].mobileNo);
        localStorage.setItem("refId", res.user[0].referenceId);
        localStorage.setItem("refType", res.user[0].referenceType);
        localStorage.setItem("radisan", res.user[0].radisanSupport);

        navigate(process.env.PUBLIC_URL + "/Main");
        //if (isLoading) {
        // }
      })
      .catch((err) => {
        setStates((prevState) => ({
          ...prevState,
          ShowErrorTxt: { show: true, txt: err.message || err },
        }));
      });
  };
  useEffect(() => {
    setStSearch((prev) => ({
      ...prev,
      searchedObject: {},
      SearchCategory: "",
      UserReceiver: "",
      SearchTitle: "",
      SearchFrom: "",
      SearchTill: "",
      RegDateTime: "",
      RegDateTimeTo: "",
      UpdateDate: "",
      UpdateDateTo: "",
      TicketOwnerGroup: "",
      TicketCreatedUser: "",
      TicketRecipientGroup: "",
      TicketReceivingUser: "",
      TicketOwnerCompany: "",
      TicketRecipientCompany: "",
      TicketAnswerStatus: "",
      TicketStatus: "",
      Importance: "",
      Satisfaction: "",
      TicketVisibilityStatus: "",
      TicketOwnerGroupAutoCompleteData: "",
      TicketCreatedUserAutoCompleteData: "",
      TicketRecipientGroupAutoCompleteData: "",
      TicketReceivingUserAutoCompleteData: "",
      TicketOwnerCompanyAutoCompleteData: "",
      TicketRecipientCompanyAutoCompleteData: "",
      TicketStatusAutoCompleteData: "",
      ImportanceAutoCompleteData: "",
      SatisfactionAutoCompleteData: "",
      TicketVisibilityStatusAutoCompleteData: "",
      Clear: "",
      ticketId: "",
    }));
  }, []);
  return (
    <div>
      <div
        id="alertDanger"
        className={`alert-danger  ${
          states.ShowErrorTxt.show
            ? "alert-danger-TicketHeading-show"
            : "alert-danger-TicketHeading-hide "
        }`}
      >
        <strong>اطلاعات نامعتبر!</strong>
        <div className="d-flex">
          <span
            id="panel-heading-span"
            onClick={() => {
              setStates((prevState) => ({
                ...prevState,
                ShowErrorTxt: { show: false, txt: "" },
              }));
            }}
          >
            ×
          </span>
          <p>{states.ShowErrorTxt.txt}</p>
        </div>
      </div>
      <div className="panel" id="dvLogin">
        <div className="panel-heading flexRow" id="loginHeading">
          <strong>ورود به سیستم</strong>
        </div>
        <div className="login">
          <div className="login-feild-box">
            <img id="usernameImg" src={email}></img>
            <input
              placeholder="آدرس ایمیل"
              type="email"
              value={stLogin["email"]}
              onChange={(e) => {
                setStLogin((prev) => ({ ...prev, email: e.target.value }));
              }}
            ></input>
          </div>
          <div className="login-feild-box m-10">
            <img id="passwordImg" src={password}></img>
            <input
              placeholder="کلمه عبور"
              type="password"
              value={stLogin["password"]}
              onChange={(e) => {
                setStLogin((prev) => ({ ...prev, password: e.target.value }));
              }}
            ></input>
          </div>
          <div>
            <button
              onClick={(e) => {
                onLogin(e, stLogin["email"], stLogin["password"]);
              }}
            >
              ورود
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
